import { render, staticRenderFns } from "./GoToPoll.vue?vue&type=template&id=7a07833f&scoped=true&"
import script from "./GoToPoll.vue?vue&type=script&lang=js&"
export * from "./GoToPoll.vue?vue&type=script&lang=js&"
import style0 from "./GoToPoll.vue?vue&type=style&index=0&id=7a07833f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a07833f",
  null
  
)

export default component.exports